import React from 'react';
import Box from '@mui/material/Box';
import { InlineWidget } from 'react-calendly';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import { brand, fonts, CALENDLY_URL, CONTACT_EMAIL } from '../theme/brand';

const Contact = () => {
  return (
    <Box sx={{ bgcolor: brand.ink, color: brand.text, fontFamily: fonts.body, minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1240, mx: 'auto', px: 3, pt: { xs: 8, md: 12 }, pb: { xs: 8, md: 12 }, display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'flex-start' }}>
        <Box sx={{ flex: '1 1 340px', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Box sx={{ fontFamily: fonts.mono, fontSize: 14, letterSpacing: '0.04em', textTransform: 'uppercase', color: brand.accent }}>
            Free · 15 minutes · No commitment
          </Box>
          <Box component="h1" sx={{ m: 0, fontFamily: fonts.display, fontWeight: 900, fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1, letterSpacing: '-0.03em', color: brand.textStrong }}>
            Tell me what you want built.
          </Box>
          <Box component="p" sx={{ m: 0, fontSize: 18, color: brand.textBody }}>
            Pick a time that works for you. No prep, no slides and no code needed. Already built something that isn't holding up? Bring that too.
          </Box>
          <Box
            component="a"
            href={`mailto:${CONTACT_EMAIL}`}
            sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1.5, p: 2.25, borderRadius: '12px', border: `1px solid ${brand.line}`, bgcolor: brand.panel, color: brand.text, textDecoration: 'none', '&:hover': { borderColor: brand.lineStrong } }}
          >
            <MailOutlineRoundedIcon aria-hidden="true" sx={{ color: brand.accent }} />
            <span>
              <Box component="span" sx={{ display: 'block', fontWeight: 600 }}>Prefer email?</Box>
              <Box component="span" sx={{ color: brand.textMuted }}>{CONTACT_EMAIL}</Box>
            </span>
          </Box>
        </Box>

        <Box sx={{ flex: '999 1 560px', minWidth: 0, bgcolor: '#FFFFFF', borderRadius: '16px', overflow: 'hidden' }}>
          <InlineWidget url={CALENDLY_URL} styles={{ height: '700px', minWidth: '320px' }} />
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;
